"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Style = exports.CSS = void 0;
var theme_1 = require("../../components/theme");
exports.CSS = {
    container: 'c-MultiListChooser',
    filter: 'c-MultiListChooser__filter',
    chooserContainer: 'c-MultiListChooser__container',
    title: 'c-MultiListChooser__title',
    group: {
        container: 'c-MultiListChooser__group',
        title: 'c-MultiListChooser__groupTitle',
        selectionWrap: 'c-MultiListChooser__groupSelectWrap',
        selection: 'c-MultiListChooser__groupSelect'
    },
    modal: 'c-MultiListChooser__modal',
    colorIndicator: 'c-MultiListChooser__colorIndicator'
};
exports.Style = (_a = {},
    _a[exports.CSS.title] = {
        'font-weight': theme_1.DefaultTheme.font.weight.bold
    },
    _a[exports.CSS.container] = {
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        'flex-direction': 'column'
    },
    _a[exports.CSS.chooserContainer] = {
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        width: '100%'
    },
    _a[exports.CSS.group.container] = {
        width: '100%',
        height: '240px',
        display: 'flex',
        'flex-direction': 'column'
    },
    _a[exports.CSS.group.title] = {
        'font-family': theme_1.DefaultTheme.font.familyCondensed,
        'font-weight': theme_1.DefaultTheme.font.weight.bold,
        'padding-bottom': theme_1.DefaultTheme.space(4)
    },
    _a[exports.CSS.group.selectionWrap] = {
        'background-color': theme_1.DefaultTheme.background.grey,
        flex: 1,
        overflow: 'auto'
    },
    _a["".concat(exports.CSS.group.container, ":nth-child(even) .").concat(exports.CSS.group.selectionWrap)] = {
        'background-color': theme_1.DefaultTheme.background.lightGrey
    },
    _a[exports.CSS.group.selection] = {
        position: 'relative',
        display: 'flex',
        '&:hover': {
            'background-color': theme_1.DefaultTheme.font.color.divider
        },
        '& input': {
            appearance: 'none',
            '&::-ms-check': {
                display: 'none' // Hide radio button for IE11
            },
            position: 'absolute'
        },
        '& input + label': {
            width: '100%',
            'border-left': "".concat(theme_1.DefaultTheme.space(1), " solid transparent"),
            'padding-left': theme_1.DefaultTheme.space(1)
        },
        '& input:focus + label': {
            outline: "1px solid ".concat(theme_1.DefaultTheme.color.accent),
            'margin-right': '1px'
        },
        '& input:checked + label': {
            'background-color': theme_1.DefaultTheme.background.offWhite,
            'border-left': "".concat(theme_1.DefaultTheme.space(1), " solid ").concat(theme_1.DefaultTheme.color.accent),
            'padding-left': theme_1.DefaultTheme.space(1),
            'box-shadow': theme_1.DefaultTheme.shadow.box.dp2
        }
    },
    _a[exports.CSS.modal] = {
        'min-width': '800px'
    },
    _a[exports.CSS.filter] = {
        display: 'flex',
        width: '100%',
        'padding-bottom': theme_1.DefaultTheme.space(4),
        '& input:hover': {
            'background-color': theme_1.DefaultTheme.font.color.divider
        },
        '& input': {
            width: '100%',
            border: "".concat(theme_1.DefaultTheme.space(1), " solid transparent"),
            'padding-left': theme_1.DefaultTheme.space(1)
        },
        '& input:focus': {
            outline: "1px solid ".concat(theme_1.DefaultTheme.color.accent),
            'margin-right': '1px'
        },
        '& input:checked': {
            'background-color': theme_1.DefaultTheme.background.offWhite,
            'border-left': "".concat(theme_1.DefaultTheme.space(1), " solid ").concat(theme_1.DefaultTheme.color.accent),
            'padding-left': theme_1.DefaultTheme.space(1),
            'box-shadow': theme_1.DefaultTheme.shadow.box.dp2
        }
    },
    _a[exports.CSS.colorIndicator] = {
        width: '12px',
        height: '12px',
        position: 'absolute',
        top: '50%',
        right: '4px',
        transform: 'translateY(-50%)',
        borderRadius: '50%'
    },
    _a);
//# sourceMappingURL=multi.list.chooser.style.js.map